import { render, staticRenderFns } from "./delete-category.vue?vue&type=template&id=7df31a54&scoped=true"
import script from "./delete-category.vue?vue&type=script&lang=js"
export * from "./delete-category.vue?vue&type=script&lang=js"
import style0 from "./delete-category.vue?vue&type=style&index=0&id=7df31a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df31a54",
  null
  
)

export default component.exports